import React from 'react';
import { makeStyles } from '@material-ui/core/styles'
import Layout from '../../../layout';
import Register from './register';
import WhyBourse from './whyBourse';
import TypesOfMarket from './TypesOfMarket';
import ServicesKala from './servicesKala';
import StepKala from './stepKala';
import Download from './download';

const useStyles = makeStyles((theme) => ({

}))


export default function Index() {

    const classes = useStyles()

    return (
        <Layout>
            <Register />
            <WhyBourse />
            <ServicesKala />
            <TypesOfMarket />
            <StepKala />
            <Download />
            <br />
            <br />
            <br />
        </Layout>
    )
}
